import { render, staticRenderFns } from "./Stretch.vue?vue&type=template&id=59aa41e0&scoped=true&"
import script from "./Stretch.vue?vue&type=script&lang=js&"
export * from "./Stretch.vue?vue&type=script&lang=js&"
import style0 from "./Stretch.vue?vue&type=style&index=0&id=59aa41e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa41e0",
  null
  
)

export default component.exports